// FormDropdown.jsx
import React from 'react';

const FormDropdown = ({ label, options, value, onChange, required }) => {
  return (
    <div className="flex flex-col space-y-2">
      {label && <label className="font-medium">{label}</label>}
      <select
        value={value}
        onChange={onChange}
        required={required}
        className="border rounded px-3 py-2"
      >
        <option value="">Select...</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FormDropdown;